import { AppConfigModel } from "../../abstract/app-config.model";
import { PaymentMethod } from "../../core/payment-method.model";

export class BankAccountLineType extends AppConfigModel {

    static override CLASS_NAME: string = 'BankAccountLineType';

    readonly allocations!: boolean;
    readonly cheque!: boolean;
    readonly client!: boolean;
    readonly creditCard!: boolean;
    readonly debitCredit!: string;
    readonly description!: string;
    readonly employee!: boolean;
    readonly final!: boolean;
    readonly invoices!: boolean;
    readonly loan!: boolean;
    readonly overpayment!: boolean;
    readonly parent!: BankAccountLineType;
    readonly paymentMethod!: boolean;
    readonly paymentMethods!: PaymentMethod[];
    readonly paymentProvider!: boolean;
    readonly shareholder!: boolean;
    readonly taxDeclaration!: boolean;
    readonly vendor!: boolean;

    public get needsDetails(): boolean {
        return (
            this.allocations ||
            this.cheque ||
            this.client ||
            this.creditCard ||
            this.employee ||
            this.invoices ||
            this.loan ||
            this.paymentMethod ||
            this.paymentProvider ||
            this.shareholder ||
            this.vendor
        );
    }
}
